import Cars from '@/components/cars';

export default Cars;
